import { render, staticRenderFns } from "./NavFooter.vue?vue&type=template&id=55de0674&scoped=true&"
import script from "./NavFooter.vue?vue&type=script&lang=ts&"
export * from "./NavFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NavFooter.vue?vue&type=style&index=0&id=55de0674&lang=stylus&scoped=true&"
import style1 from "./NavFooter.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de0674",
  null
  
)

export default component.exports